<template>
	<div class="checkInQuery">
    <!-- 固定栏 -->
    <div class="fixed-content">
      <!-- tabBtn -->
      <div class="tabBtn">
        <mt-navbar class="navBar" v-model="selected">
          <mt-tab-item class="tabBtnNav1" id="1">融合套餐问题</mt-tab-item>
          <mt-tab-item class="tabBtnNav1" id="2">我的诊断</mt-tab-item>
        </mt-navbar>
      </div>
    </div>

    <!-- 内容栏 -->
    <div class="scroll-content scroll-content1">
      <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
          <div class="noData" v-if="list.length == 0">
              <div style="padding-bottom: 7rem;">
                  <img src="static/images/default-null.png"  alt="">
                  <p>暂时无相关数据</p>
              </div>
          </div>
          <div class="padding-20 bg-fff margin-top-20"  v-for="(item, index) in list" :key="index">
          <!-- <div class="padding-20 bg-fff margin-top-20" @click="openPage('RepairMangerDetial', item)" v-for="(item, index) in list" :key="index"> -->
            <div class="listBox">
              <div class="mesList">
                <div class="title color-333 font-size-14px">报修时间：{{item.reportTime}}</div>
                <p class="color-666 font-size-26 margin-top-8">报修类型：{{item.reportType}}</p>
                <p class="color-666 font-size-26 margin-top-8">姓名：{{item.reporterName}}</p>
                <p class="color-666 font-size-26 margin-top-8">上网账号：{{item.reporterNumber}}</p>
                <p class="color-666 font-size-26 margin-top-8">报修位置：{{item.location}}</p>
                <p class="color-666 font-size-26 margin-top-8">报修原因：{{item.reportCause}}</p>
                <p class="color-666 font-size-26 margin-top-8">联系电话：{{item.reporterPhone}}</p>
              </div>
              <p class="typeStateBtn color-fff" 
              :class="{ 'bg-f9b625': item.orderStatusName == '待维修', 'bg-appStyle': item.orderStatusName == '已维修' }">{{item.orderStatusName}}</p>
            </div>
            <div class="border-top handleBoxs" v-if="selected == 1">
              <div class="handleBtn color-fff"  @click="handelItem($event, item, '无问题')">无问题</div>
              <div class="handleBtn color-fff"  @click="handelItem($event, item, '有问题')">有问题</div>
            </div>

          </div>
        </mt-loadmore>
      </div>

      <!-- 弹出框 -->
      <v-messagebox v-if="showMesBox" :mes-box-title="mesBoxTitle" :mes-box-type="mesBoxType" @change="mesBosChange"></v-messagebox>

    </div>

    
    

</template>

<script>

import Vue from 'vue'
import { mapGetters } from "vuex";
import { Navbar, TabItem } from 'mint-ui';
import { Loadmore } from 'mint-ui';
import { InfiniteScroll } from 'mint-ui';
import { Toast } from 'mint-ui';
import api from "../fetch/api";
import messagebox from "@/components/messagebox";
import { MessageBox } from 'mint-ui';


import service from "@/fetch/service";
import * as types from '@/vuex/types';
export default {
  components: {
    Navbar,
    TabItem,
    'v-messagebox': messagebox
  },
  data() {
    return {
      Url: types.URL,
      selected: '1', //默认当前的tab 页面
      pageNo: 1, //分页
      pageSize: 20, //每次请求的个数
      allLoaded: true,//是否加载完毕
      haveMore: true, //是否有更多数据
      list: [], //数据
      mesBoxTitle: {}, //弹出框的信息等
      showMesBox: false, //是否显示弹出框
      mesBoxType: 1, // 1疑难延期 2预约上门 3完成维修
      itemDate: {} //当前item的数据
    };
  },
  created() {
    this.loaddata();
  },
  computed: {
    ...mapGetters([])
  },
  mounted() {
    let that = this
  },
  watch: {
    'selected': function() {
      this.list = [];
      this.pageNo = 1;
      this.loaddata();
    }
  },
  methods: {
    //页面跳转
    openPage: function (pageName, item) {
      console.log(item)
      let type = this.selected == 2 ? 0 : 2;
      this.$router.push({name: pageName, query: {pageDate: item, type: type}});
      
    },
    //弹出框 回调函数
    mesBosChange: function (data) {
      console.log(data);
      console.log("当前选择的item--", this.itemDate);
      this.showMesBox = false;
      let diagnosisStatement = data.reason.name;
      if (data.reason.name == '其他') {
        diagnosisStatement = data.remarks
      }
      if (data.typeName == '有问题') {
        this.submit('/api/NetworkMaintain/integratedManageSave',{
          id: this.itemDate.id,
          verdict: '有问题',
          diagnosisStatement: diagnosisStatement
        })
      }
      if (data.typeName == '无问题') {
        this.submit('/api/NetworkMaintain/integratedManageSave',{
          id: this.itemDate.id,
          verdict: '无问题',
          diagnosisStatement: diagnosisStatement
        })
      }
    },
    submit(url, params) {
      let that = this
      that.$store.dispatch("setLoadingState", true);
      api.post(url, params).then(res => {
        console.log(res);
        that.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          that.pageNo = 1;
          that.loaddata(); 
        }
      })
      .catch(error => {
        that.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    },
    //关闭申请
    handelItem: function (event, item, mesBoxType) {
      let that = this;
      if(event) {
        event.stopPropagation ? event.stopPropagation(): event.cancelBubble = true;
      }
      if (mesBoxType == '有问题') {
        this.mesBoxTitle = {
          title: '问题描述',
          subTitle: '诊断说明'
        }
        that.mesBoxType = 4;
        that.showMesBox = true;
        that.itemDate = item;
      }else {
        this.mesBoxTitle = {
          title: '问题描述',
          subTitle: '诊断说明'
        }
        that.mesBoxType = 7;
        that.showMesBox = true;
        that.itemDate = item;
        
      }
    },
    loadBottom: function(){//上拉加载更多
      console.log("上拉加载更多");
      this.more();                 
      this.$refs.loadmore.onBottomLoaded();
    },
    loadTop: function(){//下拉刷新
      this.pageNo =1;
      this.loaddata();               
      this.$refs.loadmore.onTopLoaded();
    },
    more() {
      // 分页查询
      this.pageNo++;
      this.loaddata();
    },
    loaddata(){ //加载数据从vuex中拿数据
      if (this.selected == 1) {
        this.getDatas('/api/NetworkMaintain/integratedManagePage',{
          "page": this.pageNo,
          "limit": this.pageSize,
          "orderStatus": 1 //诊断单状态 1-新诊断单 2-完结单
        });
      }
      if (this.selected == 2) {
        this.getDatas('/api/NetworkMaintain/integratedManagePage',{
          "page": this.pageNo,
          "limit": this.pageSize,
          "orderStatus": 2 //诊断单状态 1-新诊断单 2-完结单
        });
      }

    },
    getDatas(url, params) {
      this.$store.dispatch("setLoadingState", true);
      api.get(url, params).then(res => {
        console.log(res);
        this.$store.dispatch("setLoadingState", false);
        let result = res.result;
        console.log(this.allLoaded);
        if (res.success) {
          let listArr = result.rows;

          if (this.pageNo == 1) {
            this.list = listArr;
            this.allLoaded = result.isLastPage;
          } else{
              this.list = this.list.concat(listArr);
              this.allLoaded = result.isLastPage;
          }
        }
        
      })
      .catch(error => {
        this.$store.dispatch("setLoadingState", false);
        console.log(error);
        Toast(error.data.msg);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/function";
$gridCell-height: px2rem(70px);
$mes-height: px2rem(120px);
$other-height: px2rem(180px);
$cutLine-height: px2rem(20px);

$content1Height: px2rem(120px);
$content2Height: px2rem(200px);
.font-size-14px {
  font-size: 14px !important;
}
.mint-tab-item-label {
  font-size: 14px !important;
}
.checkInQuery {
  .fixed-content {
    height: 100px !important;
  }
  .tabContent {
    margin-bottom: px2rem(130px);
  }
  .scroll-content1 {
    top: calc(#{$content1Height}) !important;
  }
}
.cut-line {
  height: $cutLine-height;
  background: #f5f5f5;
}
.subTitle {
  font-size: 14px;
  padding: px2rem(20px);
  font-weight: bold;
}
.HqTextarea {
  width: px2rem(500px);
  height: px2rem(150px);
  border-radius: px2rem(15px);
  padding: px2rem(20px);
  border: none;
}

.item-input {
  background: #fff;
  padding: px2rem(25px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: px2rem(10px);
  margin-top: px2rem(15px);
  .label {
    font-size: 14px;
    color: #333;
  }
  .input-text {
    flex: 1;
    text-align: right;
    font-size: 14px;
  }
}
.dropdownBox {
  margin-left: px2rem(20px);
  display: flex;
  align-items: center;
  padding: 0 px2rem(5px);
  justify-content: flex-end;
  .dropdown {
    width: px2rem(250px);
  }
  .dropArrow {
    width: px2rem(40px);
    height: px2rem(40px);
  }
}
.gzBoxs {
  display: flex;
  flex-flow: row wrap;
  .box {
      padding: px2rem(10px);
      background: #ddd;
      text-align: center;
      font-size: 14px;
      margin: px2rem(10px);
    }
}

.rooms {
  width: px2rem(450px);
  height: px2rem(200px);
  background: #fff;
  border: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: px2rem(20px);
  .textDes {
    // width: px2rem(80px);
    flex-basis: px2rem(60px);
    padding: px2rem(10px);
    text-align: center;
  }
  .allBed {
    flex: 1;
    border-left: 1px solid #333;
    border-right: 1px solid #333;
    height: px2rem(200px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: row wrap;
    .bed {
      padding: px2rem(10px);
      // height: px2rem(50px);
      // line-height: px2rem(50px);
      background: #ddd;
      text-align: center;
      font-size: 14px;
      margin: px2rem(10px);
    }
  }
}
.flex-1 {
  flex: 1;
}
.flex-basis-60 {
  flex-basis: px2rem(110px) !important;
  padding: 0 px2rem(10px);
}
.footerBtn {
  width: 100%;
  height: px2rem(80px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  position: fixed;
  bottom: 0;
  z-index: 99;
  .btn {
    width: 50%;
    text-align: center;
    height: px2rem(80px);
    line-height: px2rem(80px);
  }
}
.checkInQuery .tabBtn .navBar .tabBtnNav1 {
  padding: px2rem(30px) 0 !important;
  font-size: 14px;
}
.mint-loadmore-text {
  font-size: 14px;
}
.mint-msgbox-btn {
  font-size: 14px;
}
.listBox {
  .bg-f9b625 {
    background: #f9b625;
  }
  display: flex;
  position: relative;
  .typeStateBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: px2rem(124px);
    height: px2rem(102px);
  }
  //缩略图
  .thumbnail {
      width: px2rem(136px);
      height: px2rem(136px);
      margin-right: px2rem(30px);
      border-radius: px2rem(5px);
  }
  //缩略图-长方形
  .thumbnail-max {
      width: px2rem(210px);
      height: px2rem(136px);
      margin-right: px2rem(26px);
      border-radius: px2rem(5px);
  }
  //基本信息栏
  .mesList {
      flex: 1;
      .title {
          display: flex;
          align-items: center;
          flex: 1;
          //列表 标签
          .label {
              flex: none;
              display: inline-block;
              padding: 0 px2rem(15px);
              height: px2rem(32px);
              line-height: px2rem(32px);
              color: #fff;
              border-radius: px2rem(3px);
              margin-right: px2rem(16px);
              margin-left: px2rem(20px);
              font-size: px2rem(22px);
          }
      }
      //标签靠右-标签
      .title-label-right {
          justify-content: space-between;
      }
      p {
          color: #666;
          font-size: px2rem(26px);
          margin-top: px2rem(25px);
      }
  }
}

</style>


// WEBPACK FOOTER //
// FusePackageProblem.vue?a045bf70